import { LootboxModal } from '@/components/modals/LootboxModal';
import { useCommonStore } from '@/store';

export const useLootboxModal = () => {
  const activeLootboxId = useCommonStore.use.activeLootboxId();

  return activeLootboxId ? <LootboxModal lootboxId={activeLootboxId} /> : null;
};
